































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Dictionary } from 'vue-router/types/router';
import { Getter } from 'vuex-class';

import {
  ClosedRecurringPaymentNos,
  GetRecurringPaymentsRequest, Mall, NCPResponse,
  RecurringPayments, PutRecurringPaymentsCloseRequest,
} from 'supporter';
import cloneDeep from 'lodash.clonedeep';

import RecurringPaymentCloseInfoLayerPopup, { CloseInfoPopupData } from '@/views/order/popup/RecurringPaymentCloseInfoLayerPopup.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import {
  gridProps,
  GridProps,
  getI18nOfThis,
  makeDefaultSearchQueryObject
} from '@/components/order/detail/orderRecurringPayments/SearchResultAssistant';
import { QueryObject } from '@/components/order/detail/orderRecurringPayments/SearchForm.vue';
import ClickEvent = JQuery.ClickEvent;
import {getMallsConfigurationsByKey, convertProductUri} from '@/utils/commonUtils';
import { sanitizeRedirectPath } from '@/utils/sanitizeRedirectPath';

const PRODUCT_DETAIL_URL_MAP: {[key: string]: string} = {};

@Component({
  components: {
    ItemTable,
    RecurringPaymentCloseInfoLayerPopup,
  }
})
export default class SearchResult extends Vue {
  @Getter('mall/malls')
  private malls!: Mall[];
  private getI18nOfThis = getI18nOfThis;
  private gridData: RecurringPayments['contents'] = [];
  private gridProps: GridProps = gridProps();
  private queryObject: QueryObject = {} as QueryObject;
  private closeInfoPopupVisible = false;
  private closeInfoPopupData: CloseInfoPopupData = {} as CloseInfoPopupData;

  private mounted() {
    // 그리드 '해지 상세정보' 의 '보기' 버튼에 이벤트 리스너 등록 (gridProps의 closeInfo 참고)
    $('body').on('click', '.order-recurring-payments__close-info-btn', this.handleCloseInfoBtnClick);
    getMallsConfigurationsByKey(this, 'MALL_PRODUCT').then((data: { productDetailUrl: string, mallNo: number }[]) => {
      data.forEach(({ productDetailUrl, mallNo }) => PRODUCT_DETAIL_URL_MAP[mallNo] = productDetailUrl);
      $('body').on('click', '[name=recurringPaymentProductNoBtn]', this.handleRecurringPaymentProductNoBtnClick);
    });
  }

  private beforeDestroy() {
    $('body').off('click', '.order-recurring-payments__close-info-btn', this.handleCloseInfoBtnClick);
    $('body').off('click', '[name=recurringPaymentProductNoBtn]', this.handleRecurringPaymentProductNoBtnClick);
  }

  @Watch('$route.query', { immediate: true })
  private mapQueryObject(query: Dictionary<string | string[]>): void {
    let queryObject;

    if (!Object.keys(query).length) {
      const defaultQueryObject = makeDefaultSearchQueryObject(this.malls.map((mall: Mall) => mall.mallNo))
      queryObject = cloneDeep(defaultQueryObject);
    }
    else {
      queryObject = this.$route.query as unknown as QueryObject;
      delete queryObject['dataRefresh'];
    }
    this.queryObject = queryObject;
  }

  @Watch('queryObject', { immediate: true })
  @Watch('gridProps.options.pageOptions.page')
  @Watch('gridProps.options.pageOptions.perPage')
  private async fetchGridData(): Promise<void> {
    const { page, perPage } = this.gridProps.options.pageOptions;

    const recurringPaymentsData = await this.getRecurringPayments(page, perPage);
    this.gridData = recurringPaymentsData.contents;
    this.gridProps.options.pageOptions.totalCount = recurringPaymentsData.totalCount;
  }

  private async getRecurringPayments(page: number, size: number): Promise<RecurringPayments> {
    const request: GetRecurringPaymentsRequest = {
      params: {
        ...this.queryObject,
        page: page,
        size: size,
      }
    };

    try {
      const response: NCPResponse<RecurringPayments> = await this.$api.getRecurringPayments(request);
      return response.data;
    } catch (e) {
      console.error(e);
    }

  }

  private setPageData(page: number = 1, size?: number) {
    if (size) {
      this.gridProps.options.pageSize = size.toString();
      this.gridProps.options.pageOptions.perPage = size;
    }
    this.gridProps.options.pageOptions.page = page;
  }

  private async handleCloseRecurringPaymentsBtnClick(): Promise<void> {
    const checkedRows = (this.$refs.itemTable as ItemTable).gridFunction('getCheckedRows');

    if (confirm(this.getI18nOfThis('CLOSE_RECURRING_PAYMENTS_CONFIRM_TEXT'))) {
      if (!checkedRows.length) {
        alert(this.getI18nOfThis('NO_SELECTED_PRODUCT_ALERT_TEXT'));
        return;
      }

      const checkedRecurringPaymentNos = checkedRows.map(row => row.recurringPaymentNo);
      await this.putRecurringPaymentsClose(checkedRecurringPaymentNos);
      alert(this.getI18nOfThis('CLOSE_SUCCESS_ALERT_TEXT'));
      this.fetchGridData();
    }
  }

  private async putRecurringPaymentsClose(recurringPaymentsNos: number[]): Promise<ClosedRecurringPaymentNos> {
    const request: PutRecurringPaymentsCloseRequest = {
      data: {
        recurringPaymentNos: recurringPaymentsNos,
      }
    }

    try {
      const response: NCPResponse<ClosedRecurringPaymentNos> = await this.$api.putRecurringPaymentsClose(request);
      return response.data;
    } catch (e) {
      console.error(e);
    }
  }

  private handleRecurringPaymentProductNoBtnClick(e: ClickEvent): void {
    e.preventDefault();
    const $btn = $(e.currentTarget);
    const mallNo = $btn.data('mall-no');
    const productNo = $btn.data('product-no');
    const redirectUrl = convertProductUri(PRODUCT_DETAIL_URL_MAP[mallNo], productNo)

    window.open(sanitizeRedirectPath(redirectUrl));
  }

  private handleCloseInfoBtnClick(e: ClickEvent): void {
    e.preventDefault();
    const $btn = $(e.currentTarget);
    const closeReason = $btn.data('close-reason');
    const closeReasonDetail = $btn.data('close-reason-detail');

    this.closeInfoPopupData = {
      closeReason: closeReason,
      closeReasonDetail: closeReasonDetail,
    }
    this.closeInfoPopupVisible = true;
  }
}

